import { useEffect, useState } from "react"
import { useParams } from "react-router";
import { Button } from "components/Button";
import { iconDownload } from "assets/icons";
import { useAuth } from "hooks/useAuth";
import { convertDateToShowInput } from "utils/formattingInputs";

interface ParamsProps {
  id: string;
}

interface BusinessTrustTableRowProps {
  verifiedAt: string,
  score?: string,
  scoreFormatted?: string,
  suggestion?: string,
  downloadLink: JSX.Element,
}

export const useBusinessTrust = () => {
  const [businessTrustTableRows, setBusinessTrustTableRows] = useState<BusinessTrustTableRowProps[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [sendingBusinessTrust, setSendingBusinessTrust] = useState<boolean>(false);
  const [hasError, setHasError] = useState<boolean>(false);
  const { id } = useParams<ParamsProps>();
  const {connectApi} = useAuth();

  useEffect(() => {
    getData();
  }, [])

  /* API CALLS */
  const getData = async () => {
    setIsLoading(true);
    connectApi({
      type: 'get',
      url: `sellers/${id}/business-trust`,
      errorMessage: 'Falha ao carregar dados do Business Trust',
    }).then((response) => {
      const responseDecoded = response.data;
      setHasError(false);
      setBusinessTrustTableRows(
        responseDecoded.map((item:any) => (
          {
            verifiedAt: convertDateToShowInput(item.date),
            score: Number(item.score).toFixed(2),
            scoreFormatted: Number(item.score).toFixed(2).replace(".", ","),
            suggestion: Number(item.score).toFixed(2),
            downloadLink: downloadLink(item.analysisId),
          }
        ))
      );
    })
    .catch((_) => setHasError(true))
    .finally(() => setIsLoading(false));
  }

  const sendBusinessTrust = () => {
    setSendingBusinessTrust(true);
    connectApi({
      type: 'post',
      url: `sellers/${id}/business-trust`,
      successMessage: 'Business trust atualizado com sucesso',
    }).then((_) => {
      getData()
    }).finally(() => setSendingBusinessTrust(false))
  }

  const downloadLink = (analysisId: number) => {
    return (
      <Button
        size="small"
        onlyIcon={true}
        icon={iconDownload}
        onClick={() => downloadReportBusinessTrust(analysisId)}
      />
    )
  }

  const downloadReportBusinessTrust = async (analysisId: number) => { 
    connectApi({
      type: 'get',
      url: `/sellers/${id}/business-trust/${analysisId}`
    })
  }

  /* EXPORTED VALUES */
  return {
    businessTrustTableRows,
    isLoading,
    hasError,
    sendingBusinessTrust,
    sendBusinessTrust,
  }
}